<template>
  <v-app-bar
    :height="height"
    :class="{'v-toolbar--transparent': isDashboard && $vuetify.breakpoint.mdAndUp }"
    :clipped-left="$vuetify.breakpoint.mdAndDown"
    :absolute="isDashboard"
    color="white"
    :style="{ top: `${isDashboard ? 0 : verticalOffset}px` }"
    app>
    <v-btn
      class="v-toolbar__drawer-btn grow--sm-left cy-open-navigation"
      elevation="1"
      color="white"
      small
      fab
      @click="$store.commit('common/setSidebarVisible', !sidebarVisible)">
      <v-icon :color="sidebarVisible ? 'primary' : ''">$burger</v-icon>
    </v-btn>
    <v-toolbar-title v-if="!isDashboard">{{ title }}</v-toolbar-title>
    <c-logo />
    <v-spacer></v-spacer>
    <provider-set-online v-if="account && account.role === 'PROVIDER'" class="grow--sm-left" />
    <div class="v-toolbar__actions">
      <!-- SUPER ADMIN -->
      <!-- <v-btn v-if="isVisible('appSettings') && account.role === 'PATIENT'" color="white" fab>-->
      <!--        <v-icon>mdi-dots-vertical</v-icon>-->
      <!--      </v-btn> -->
      <template v-if="account && account.role === 'SUPER_ADMIN'">
        <v-btn v-if="isVisible('createSuperAdmin')" :to="{ name: 'CreateSuperAdmin' }" color="primary" large>
          {{ $t('buttons.createSuperAdmin') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn v-if="isVisible('createClinicAdmin')" :to="{ name: 'CreateClinicAdmin' }" color="primary" large>
          {{ $t('buttons.createClinicAdmin') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn v-if="isVisible('createClinic')" :to="{ name: 'CreateClinic' }" color="primary" large>
          {{ $t('buttons.createClinic') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn v-if="isVisible('createPatientBySA')" :to="{ name: 'CreatePatient' }" color="primary" large>
          {{ $t('buttons.createPatient') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn v-if="isVisible('createProviderBySA')" :to="{ name: 'CreateProvider' }" color="primary" large>
          {{ $t('buttons.createProvider') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-if="account && account.role === 'CLINIC_ADMIN'">
        <v-btn
          v-if="isVisible('createProvider')"
          class="v-btn--no-bg"
          outlined
          :to="{ name: 'CreateProvider' }"
          color="primary"
          large>
          {{ $t('buttons.createProvider') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="isVisible('createPatient')"
          class="v-btn--no-bg"
          outlined
          :to="{ name: 'CreatePatient' }"
          color="primary"
          large>
          {{ $t('buttons.createPatient') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <!-- PATIENT -->
      <template v-if="account && account.role === 'PATIENT'">
        <booking-menu v-if="isVisible('bookAppointment')" />
        <v-btn v-if="isVisible('booking')" :to="{ name: 'Booking' }" color="primary" large :disabled="account?.dependent && !myGuardianDocAllowance">
          {{ $t('buttons.booking') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <!-- CLINIC_ADMIN -->
      <template v-if="account && account.role === 'CLINIC_ADMIN'">
        <v-btn
          v-if="isVisible('bookAppointment') && isClinicAdminAndHasPermissions && $route.name !== 'Booking'"
          :to="{ name: 'Booking' }"
          depressed
          large
          color="primary">
          {{ $t('buttons.booking') }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </div>
    <!-- COMMON -->
    <!--<help v-if="account.role === 'PATIENT'" />-->
    <waiting-room v-if="account && account.role === 'PROVIDER' && ($vuetify.breakpoint.smAndDown || $route.name !== 'Dashboard')" />
    <!-- <requested-messages v-if="account && account.role === 'CLINIC_ADMIN'" /> -->
    <!--<notifications />-->
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import { PERMISSIONS } from '@/common/constants';
import CLogo from '@/components/ui/CLogo';
import externalServicesMixin from '@/common/mixins/externalServicesMixin';

export default {
  name: 'LHeader',
  components: {
    CLogo,
    BookingMenu: () => import(/* webpackChunkName: "booking-menu" */ './components/BookingMenu'),
    WaitingRoom: () => import(/* webpackChunkName: "waiting-room" */ '@/components/menus/WaitingRoom'),
    ProviderSetOnline: () => import(/* webpackChunkName: "provider-set-online" */ './components/ProviderSetOnline'),
    // RequestedMessages: () => import(/* webpackChunkName: "requested-messages" */ '@/components/menus/RequestedMessages'),
    // Notifications: () => import(/* webpackChunkName: "notifications" */ '@/components/menus/Notifications'),
    // Help: () => import(/* webpackChunkName: "help" */ '@/components/menus/Help'),
  },
  props: {
    verticalOffset: { type: Number, default: 0 },
  },
  mixins: [externalServicesMixin],
  computed: {
    ...mapState('common', ['sidebarVisible']),
    ...mapState('loggedAccount', ['account']),
    title() {
      if (this.$route.name === 'Dashboard' && this.account.role === 'CLINIC_ADMIN') {
        return this.$t('headerTitles.Appointments');
      }

      if (this.$route.meta.title) {
        return this.$t(this.$route.meta.title);
      }
      return null;
    },
    isDashboard() {
      return this.account && (this.account.role === 'PATIENT' || this.account.role === 'PROVIDER')
      && this.$route.name === 'Dashboard';
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 60;
        case 'sm': return 70;
        case 'md': return 80;
        case 'lg': return 90;
        default: return 100;
      }
    },
    isClinicAdminAndHasPermissions() {
      return this.account && this.account.role === 'CLINIC_ADMIN'
      && this.$accountHasPermission(PERMISSIONS.MANAGE_APPOINTMENTS);
    },
    myGuardianDocAllowance() {
      return this.checkSubscriptionForMyGuardianDocMain(false);
    },
  },
  methods: {
    isVisible(elementName) {
      if (!this.$route.meta.showToolbarElements) return false;
      return this.$route.meta.showToolbarElements.includes(elementName);
    },
  },
};
</script>
